// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"362":"4ad867e9","641":"c89050e6"}[chunkId] + ".chunk.js";
};